/**
 * Paso imagen desde Text-to-image → Editor IA (AIGeneration) vía sessionStorage + navegación.
 */

export const AI_EDITOR_IMPORT_FROM_TEXT_TO_IMAGE_KEY =
  "wembii_ai_editor_import_from_text_to_image";

export interface AiEditorImportFromTextToImagePayload {
  imageUrl: string;
  prompt?: string;
  /** Rotación en grados (0, 90, 180, 270) como en la tarjeta de resultado */
  rotationDeg?: number;
}

export function storeAiEditorImportFromTextToImage(
  payload: AiEditorImportFromTextToImagePayload
): void {
  try {
    sessionStorage.setItem(
      AI_EDITOR_IMPORT_FROM_TEXT_TO_IMAGE_KEY,
      JSON.stringify(payload)
    );
  } catch {
    // ignore quota / private mode
  }
}

export function readAiEditorImportFromTextToImage():
  | AiEditorImportFromTextToImagePayload
  | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(AI_EDITOR_IMPORT_FROM_TEXT_TO_IMAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AiEditorImportFromTextToImagePayload;
    if (!parsed?.imageUrl || typeof parsed.imageUrl !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearAiEditorImportFromTextToImage(): void {
  try {
    sessionStorage.removeItem(AI_EDITOR_IMPORT_FROM_TEXT_TO_IMAGE_KEY);
  } catch {
    // ignore
  }
}

/** Lee el payload y lo borra del storage (una sola vez; evita doble import en React Strict Mode). */
export function takeAiEditorImportFromTextToImage():
  | AiEditorImportFromTextToImagePayload
  | null {
  const p = readAiEditorImportFromTextToImage();
  if (p) clearAiEditorImportFromTextToImage();
  return p;
}
